export default {
  'Please enter an account': '请输入您的账号',
  'Please input a password': '请输入您的密码',
  'Please enter the verification code': '请输入验证码',
  'Hold session': '保持会话',
  'Sign in': '登录',
  'The verification code length must be between 4 and 6 bits':
    '验证码长度必须在4到6位之间'
}
